import React, { PureComponent, Fragment } from 'react';
import { FieldArray, getIn, ArrayHelpers } from 'formik';

// COMPONENTS
import { AddButton } from 'components/Buttons';

class ListField extends PureComponent<{
  name: string;
  itemComponent: React.ComponentType<{
    index: number;
    name: string;
    required?: boolean;
    item: any;
    removeFromList?: (index: number) => void;
    listReplace?: ArrayHelpers['replace'];
    listSwap?: ArrayHelpers['swap'];
    listInsert?: ArrayHelpers['insert'];
    errorObj?: object;
  }>;
  disabled?: boolean;
  required?: boolean;
  showAddButton?: boolean;
  itemModel?: any;
  AddRowMessage?: string;
  NoItemsMessage?: string;
}> {
  helpers: {
    push: (obj: any) => void;
    handlePush: (obj: any) => () => void;
    swap: (indexA: number, indexB: number) => void;
    handleSwap: (indexA: number, indexB: number) => () => void;
    move: (from: number, to: number) => void;
    handleMove: (from: number, to: number) => () => void;
    insert: (index: number, value: any) => void;
    handleInsert: (index: number, value: any) => () => void;
    replace: (index: number, value: any) => void;
    handleReplace: (index: number, value: any) => () => void;
    unshift: (value: any) => number;
    handleUnshift: (value: any) => () => void;
    handleRemove: (index: number) => () => void;
    handlePop: () => () => void;
    remove<T>(index: number): T;
    pop<T>(): T;
  };

  static defaultProps = {
    disabled: false,
    required: false,
    showAddButton: true,
    itemModel: {},
    AddRowMessage: undefined,
    NoItemsMessage: undefined,
  };

  render() {
    const { name, required, itemComponent: ItemComponent, ...rest } = this.props;

    return (
      <FieldArray name={name} validateOnChange={false}>
        {({ form, name: itemName, ...arrayHelpers }) => {
          this.helpers = arrayHelpers;

          const { values } = form;

          const items = values[name] || [];
          const removeFromList = (index: number) => {
            // For the list lists we set our errors as an object because we index the errors
            // per field name and formik asumes errors are an array
            // Trying to update the errors from the field is going to be make the application crash
            // clearing the field error before removing it from the list as a workaround of this issue
            // https://github.com/jaredpalmer/formik/issues/1158
            // @ts-expect-error TS(2345): Argument of type 'undefined[]' is not assignable t... Remove this comment to see the full error message
            form.setFieldError(name, []);

            arrayHelpers.remove(index);
          };

          const children = items.map((item, index) => (
            <ItemComponent
              key={index}
              {...rest}
              index={index}
              name={itemName}
              required={required}
              item={item}
              removeFromList={removeFromList}
              listReplace={arrayHelpers.replace}
              listSwap={arrayHelpers.swap}
              listInsert={arrayHelpers.insert}
              errorObj={getIn(form.errors, `${name}[${index}]`)}
            />
          ));

          return (
            <>
              {children}
              {!items.length && this.props.NoItemsMessage}
              {this.props.showAddButton && !this.props.disabled && (
                <AddButton
                  onClick={() => {
                    arrayHelpers.push({ ...this.props.itemModel });
                  }}
                >
                  {this.props.AddRowMessage}
                </AddButton>
              )}
            </>
          );
        }}
      </FieldArray>
    );
  }
}

const FormListField = ListField;
export default FormListField;
